import { createApp } from 'vue';
import App from './App.vue';
import './styles/studio.css';
import './styles/app.css';
import * as C from '@/domain';
import * as X from '@/export';
import { app, shownBuild, snap, ui, viewerRef } from '@/app/state';
import { announce, toast } from '@/app/announce';
import { exportBlocker, go, lockReason, pendingCritical, select, setSheet, stepState } from '@/app/navigation';
import { chooseStyle, requestAnalysis, runAnalysis, startManual } from '@/app/analysis';
import { savePicture } from '@/app/exports';
import * as F from '@/families/registry';
import { browserCopyKey, flushSave } from '@/app/persistence';

if (new URLSearchParams(location.search).has('construction')) {
  void import('./components/ConstructionPreview.vue').then(({ default: Preview }) => createApp(Preview).mount('#app'));
} else createApp(App).mount('#app');

/**
 * Test and debugging hook (the prototype's `window.studio`): read-only views of the state plus the
 * navigation and Look actions the Playwright suites drive. Not used by the app itself.
 */
const studio = {
  C, X, F,
  get store() { return app.store; },
  get step() { return ui.step; },
  get sel() { return ui.sel; },
  get inspect() { return ui.inspect; },
  get explode() { return ui.explode; },
  get viewing() { return app.store.viewing; },
  get analysis() { return ui.analysis; },
  get projectId() { return ui.projectId; },
  get booted() { return ui.booted; },
  get sheet() { return ui.sheet; },
  get empty() { return ui.empty; },
  get stage() { return { viewer: viewerRef.value }; },
  get shownBuild() { return shownBuild.value; },
  get snap() { return snap.value; },
  ui, browserCopyKey, flushSave,
  go, select, setSheet, toast, announce, stepState, lockReason, pendingCritical, exportBlocker,
  requestAnalysis, runAnalysis, startManual, chooseStyle, savePicture,
};
(window as unknown as { studio: typeof studio }).studio = studio;
